import { Typography, Stack, Box, Divider } from '@mui/material'
import { convertMinutesToHoursAndMinutes } from '@shared/common'
import { i18WithDefault as t } from '@shared/locales'
import { PaymentSettingAdminDto } from 'service-api/src/types'

export interface FeeStructureProps {
  title: string
  fees: PaymentSettingAdminDto[]
  type: 'earlyArrival' | 'lateDeparture'
}

export const FeeStructure = ({ title, fees, type }: FeeStructureProps) => {
  const generateFeeStructureText = (fee: PaymentSettingAdminDto, feeIdx: number) => {
    const orMoreText = feeIdx === fees.length - 1 ? t('feeStructure.orMore') : ''
    switch (type) {
      case 'earlyArrival': {
        return (
          <Box display="flex" flexDirection="row" alignItems="center" justifyContent="space-between">
            <Typography variant="body2">
              {convertMinutesToHoursAndMinutes(fee.before!)} {orMoreText} {t('feeStructure.early')}
            </Typography>
            <Typography variant="body2">${fee.value}</Typography>
          </Box>
        )
      }
      case 'lateDeparture': {
        return (
          <Box display="flex" flexDirection="row" alignItems="center" justifyContent="space-between">
            <Typography variant="body2">
              {convertMinutesToHoursAndMinutes(fee.after!)} {orMoreText} {t('feeStructure.late')}
            </Typography>
            <Typography variant="body2">${fee.value}</Typography>
          </Box>
        )
      }
      default: {
        return
      }
    }
  }

  return (
    <Stack>
      <Stack flexDirection="row" alignItems="center" px={1}>
        <Typography variant="body2bold">{title}:</Typography>
      </Stack>
      <Divider sx={{ m: 1 }} />
      <Stack>
        {fees
          .sort((feeA, feeB) => (type === 'earlyArrival' ? feeA.before! - feeB.before! : feeA.after! - feeB.after!))
          .map((fee, feeIdx: number) => (
            <Stack key={feeIdx} px={1}>
              {generateFeeStructureText(fee, feeIdx)}
              {feeIdx !== fees.length - 1 && <Divider sx={{ my: 1 }} />}
            </Stack>
          ))}
      </Stack>
    </Stack>
  )
}
